import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import marketingActions from "ducks/marketing";
import TermsAndPrivacyPolicy from "components/v3/terms-and-privacy-policy/TermsAndPrivacyPolicy";

const mapStateToProps = (state) => {
    const {
        country,
        config: {
            bloombergSiteUrl
        },
        marketing: {
            isOptedIn
        }
    } = state;

    return {
        country,
        bloombergSiteUrl,
        isOptedIn
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onMarketingOptInChange({ checked }) {
            dispatch(marketingActions.setIsOptedIn(checked));
            ownProps.onMarketingOptInChange(checked);
        }
    };
};

const TermsAndPrivacyPolicyContainer = (props) => {
    return (
        <TermsAndPrivacyPolicy { ...props } />
    );
};

const ConnectedTermsAndPrivacyPolicyContainer = connect(mapStateToProps, mapDispatchToProps)(TermsAndPrivacyPolicyContainer);

ConnectedTermsAndPrivacyPolicyContainer.propTypes = {
    isForAccountCreation: PropTypes.bool,
    onMarketingOptInChange: PropTypes.func
};

ConnectedTermsAndPrivacyPolicyContainer.defaultProps = {
    isForAccountCreation: true,
    onMarketingOptInChange: () => {}
};

export default ConnectedTermsAndPrivacyPolicyContainer;
